<div
  class="ui-app-layout__header-wrapper"
  [class.ui-app-layout__header-wrapper--portal]="variant() === 'portal'"
  [class.ui-app-layout__header-wrapper--portal-collapsed]="
    variant() === 'portal' && effectiveSidebarCollapsed()
  "
  role="banner"
>
  <ui-app-header
    [variant]="variant() === 'portal' ? 'portal' : 'system'"
    [logoSrc]="variant() === 'portal' ? null : logoSrc()"
    [logoAlt]="logoAlt()"
    [logoHref]="logoHref()"
    [navTitle]="navTitle()"
    [mobileNavTitle]="mobileNavTitle()"
    [userAvatarLabel]="userAvatarLabel()"
    [profileUserName]="profileUserName()"
    [profileUserRole]="profileUserRole()"
    [profileUserEmail]="profileUserEmail()"
    [profileMenuItems]="profileMenuItems()"
    [showHome]="showHome()"
    [showCompanyFilter]="showCompanyFilter()"
    [showMessages]="showMessages()"
    [messageCount]="messageCount()"
    [notificationCount]="notificationCount()"
    [notificationItems]="notificationItems()"
    [showMenuToggle]="
      (variant() === 'sidebar' || variant() === 'portal') && !isTabletChrome()
    "
    menuToggleTooltip=""
    (menuToggleClick)="onMenuToggle()"
    (homeClick)="homeClick.emit()"
    (logoutClick)="logoutClick.emit()"
    (profileMenuItemClick)="profileMenuItemClick.emit($event)"
    (notificationItemSelect)="notificationItemSelect.emit($event)"
    (notificationViewAll)="notificationViewAll.emit()"
  >
    @if (variant() !== 'portal') {
      <ng-content select="[data-ui-app-header-logo]" />
    }
    <ng-container ngProjectAs="[data-ui-app-header-nav]">
      <ng-content select="[data-ui-app-header-nav]" />
    </ng-container>
    <!-- Mismo patrón que nav: ngProjectAs para reproyectar el slot al header -->
    <ng-container ngProjectAs="[data-ui-app-header-end-start]">
      <ng-content select="[data-ui-app-header-end-start]" />
    </ng-container>
  </ui-app-header>
</div>

@if (variant() === 'sidebar' || variant() === 'portal') {
  @if (drawerOpen()) {
    <button
      type="button"
      class="ui-app-layout__drawer-backdrop"
      aria-label="Cerrar menú"
      (click)="closeDrawer()"
    ></button>
  }

  <div
    class="ui-app-layout__sidebar-wrapper"
    [class.ui-app-layout__sidebar-wrapper--collapsed]="
      effectiveSidebarCollapsed()
    "
    [class.ui-app-layout__sidebar-wrapper--portal]="variant() === 'portal'"
    [class.ui-app-layout__sidebar-wrapper--drawer-open]="drawerOpen()"
  >
    <ui-app-sidebar
      [variant]="variant() === 'portal' ? 'portal' : 'system'"
      [logoSrc]="variant() === 'portal' ? logoSrc() : null"
      [logoAlt]="logoAlt()"
      [items]="sidebarItems()"
      [selectedValue]="sidebarSelectedValue()"
      [collapsed]="isCompactChrome() ? false : effectiveSidebarCollapsed()"
      [ariaLabel]="sidebarAriaLabel()"
      (itemSelect)="onSidebarItemSelect($event)"
    />
  </div>
}

@if (variant() !== 'welcome' && showMenubar()) {
  <div
    class="ui-app-layout__menubar-wrapper"
    [class.ui-app-layout__menubar-wrapper--sidebar]="
      variant() === 'sidebar' || variant() === 'portal'
    "
    [class.ui-app-layout__menubar-wrapper--sidebar-collapsed]="
      (variant() === 'sidebar' || variant() === 'portal') &&
      effectiveSidebarCollapsed()
    "
    role="navigation"
    aria-label="Menú principal"
  >
    <ui-menubar
      [items]="menubarItems()"
      [ariaLabel]="menubarAriaLabel()"
      [horizontalScroll]="menubarHorizontalScroll()"
    >
      <ng-content select="[data-ui-menubar-start]" />
      <ng-content select="[data-ui-menubar-end]" />
    </ui-menubar>
  </div>
}

<main
  class="ui-app-layout__main"
  [class.ui-app-layout__main--welcome]="variant() === 'welcome'"
  [class.ui-app-layout__main--sidebar]="
    variant() === 'sidebar' || variant() === 'portal'
  "
  [class.ui-app-layout__main--sidebar-collapsed]="
    (variant() === 'sidebar' || variant() === 'portal') &&
    effectiveSidebarCollapsed()
  "
  [class.ui-app-layout__main--with-bottom-nav]="showBottomNav()"
  [class.ui-app-layout__main--sidebar-with-menubar]="
    (variant() === 'sidebar' || variant() === 'portal') &&
    showMenubar() &&
    menubarItems().length > 0
  "
  [attr.aria-label]="mainLabel()"
>
  @if (variant() !== 'welcome' && showTitleBar()) {
    <div class="ui-app-layout__title-bar-wrapper">
      <ui-title-bar
        [mode]="titleBarMode()"
        [title]="title()"
        [breadcrumbItems]="breadcrumbItems()"
        [breadcrumbHome]="breadcrumbHome()"
        [breadcrumbAriaLabel]="breadcrumbAriaLabel()"
        [showSecondFilterRow]="showSecondFilterRow()"
        [showAdditionalFilterRows]="showAdditionalFilterRows()"
      >
        <div data-ui-title-bar-before-end>
          <ng-content select="[slot-title-bar-before-end]" />
        </div>
        <ng-content select="[slot-title-bar-end]" />
        <div data-ui-title-bar-row>
          <ng-content select="[slot-title-bar-row]" />
        </div>
        <div data-ui-title-bar-more>
          <ng-content select="[slot-title-bar-more]" />
        </div>
      </ui-title-bar>
    </div>
  }

  <div class="ui-app-layout__below-title-bar">
    <ng-content select="[slot-below-title-bar]" />
  </div>

  <div #contentRef class="ui-app-layout__content">
    <ng-content />
  </div>
</main>

@if (showBottomNav()) {
  <div class="ui-app-layout__bottom-nav-wrapper">
    <ui-bottom-navigation
      [items]="bottomNavItems()"
      [selectedValue]="sidebarSelectedValue()"
      [ariaLabel]="bottomNavAriaLabel()"
      (itemSelect)="onSidebarItemSelect($event)"
    />
  </div>
}
